/* SK product page: gallery, variants, quantity, sticky add to cart, free-delivery note, back-in-stock sign-up. Adding to cart is left to the
   theme's own .js_add_to_cart_button handler (it posts the form and opens the cart drawer); Kaching Bundles hooks the same form. */
(function () {
  var root = document.querySelector('[data-skp]');
  if (!root) return;

  var money = function (p) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(p / 100); }
    catch (e) { return '£' + (p / 100).toFixed(2); }
  };

  /* Gallery */
  var track = root.querySelector('[data-skp-track]');
  var thumbs = root.querySelectorAll('[data-skp-go]');
  var cur = root.querySelector('[data-skp-cur]');
  function goTo(i) {
    if (!track) return;
    var slide = track.children[i];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goTo(+t.getAttribute('data-skp-go')); });
  });
  if (track) {
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (cur) cur.textContent = i + 1;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        track.querySelectorAll('video').forEach(function (v) { var s = v.closest('.skp-gal__slide'); if (!v.paused && s !== track.children[i]) v.pause(); });
      }, 80);
    });
  }

  /* Variants */
  var form = root.querySelector('#skp-form');
  var atc = form && form.querySelector('.skp-atc');
  var idInput = form && form.querySelector('[data-skp-id]');
  var qtyInput = form && form.querySelector('input[name="quantity"]');
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-skp-variants]').textContent); } catch (e) {}

  /* Back in stock: Klaviyo's client API subscribes the email to the sold-out variant. Klaviyo's Back in Stock flow
     sends the email once Shopify shows stock again. */
  var notify = root.querySelector('[data-skp-notify]');
  var nForm = notify && notify.querySelector('[data-skp-notify-form]');
  var nMsg = notify && notify.querySelector('[data-skp-notify-msg]');
  function resetNotify() {
    if (!nForm) return;
    nForm.hidden = false;
    nMsg.hidden = true;
    nMsg.classList.remove('is-err');
  }
  function notifyMsg(txt, err) {
    nMsg.textContent = txt;
    nMsg.hidden = false;
    nMsg.classList.toggle('is-err', !!err);
  }
  if (nForm) {
    nForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = nForm.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { notifyMsg('Please enter a valid email address.', true); nForm.email.focus(); return; }
      var btn = nForm.querySelector('button');
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(notify.getAttribute('data-klaviyo')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + idInput.value } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        nForm.hidden = true;
        notifyMsg('Thanks, we’ll email ' + email + ' as soon as it’s back.');
      }).catch(function () {
        notifyMsg('Sorry, that didn’t go through. Please try again.', true);
      }).then(function () { btn.disabled = false; });
    });
  }

  function set(sel, txt, show) {
    var el = root.querySelector(sel);
    if (!el) return;
    if (txt !== null) el.textContent = txt;
    if (show !== undefined) el.hidden = !show;
  }
  function setVariant(id) {
    var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v || !form) return;
    idInput.value = v.id;
    atc.setAttribute('data-pid', v.id);
    atc.disabled = !v.available;
    atc.classList.remove('added');
    atc.querySelector('.text').textContent = v.available ? 'Add to cart' : 'Sold out';
    var onSale = v.compare > v.price;
    set('[data-skp-price]', money(v.price));
    set('[data-skp-was]', money(v.compare), onSale);
    set('[data-skp-save]', onSale ? 'Save ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : '', onSale);
    set('[data-skp-optval]', v.title);
    if (notify) {
      notify.hidden = v.available;
      resetNotify();
    }
    var sp = document.querySelector('[data-skp-sticky-price]');
    if (sp) sp.textContent = money(v.price);
    var stock = root.querySelector('[data-skp-stock]');
    if (stock) {
      stock.classList.toggle('is-out', !v.available);
      stock.classList.toggle('is-low', v.available && v.left > 0 && v.left <= 5);
      stock.textContent = !v.available ? 'Out of stock' : (v.left > 0 && v.left <= 5 ? 'Only ' + v.left + ' left in stock' : 'In stock');
    }
    if (v.media && track) {
      Array.prototype.forEach.call(track.children, function (s, i) { if (s.getAttribute('data-media-id') === String(v.media)) goTo(i); });
    }
    if (history.replaceState) {
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    syncSticky();
  }
  if (form) {
    form.querySelectorAll('input[name="skp-variant"]').forEach(function (r) {
      r.addEventListener('change', function () { setVariant(r.value); });
    });
    var sel = form.querySelector('[data-skp-select]');
    if (sel) sel.addEventListener('change', function () { setVariant(sel.value); });

    form.querySelectorAll('[data-skp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + +b.getAttribute('data-skp-qty'));
        qtyInput.value = n;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Enter key: use the ajax add (theme handler) instead of a full page submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc && !atc.disabled) atc.click();
    });
  }

  /* Free delivery note: shown once the basket has something in it, refreshed after each add */
  var free = root.querySelector('[data-skp-free]');
  var threshold = +root.getAttribute('data-threshold') || 2500;
  function refreshFree() {
    if (!free || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) { free.hidden = true; return; }
      var rem = threshold - c.total_price;
      free.textContent = rem > 0 ? 'You’re ' + money(rem) + ' away from free UK delivery' : 'Your basket qualifies for free UK delivery';
      free.hidden = false;
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js_add_to_cart_button, .skp-sticky__btn, .js-remove-item')) setTimeout(refreshFree, 1800);
  });

  /* Sticky add to cart (phones and tablets): shows once the main button has scrolled above the screen.
     When the chosen size is sold out it becomes "Notify me" and jumps to the sign-up. */
  var bar = root.querySelector('[data-skp-sticky]');
  var barBtn = bar && bar.querySelector('[data-skp-sticky-btn]');
  function syncSticky() {
    if (!barBtn || !atc) return;
    var loading = atc.classList.contains('ajax_loading');
    var added = atc.classList.contains('added');
    var out = atc.disabled;
    barBtn.disabled = out && !notify;
    barBtn.classList.toggle('is-loading', loading);
    barBtn.classList.toggle('is-added', added);
    barBtn.textContent = out ? (notify ? 'Notify me' : 'Sold out') : (added ? '✓ Added' : 'Add to cart');
  }
  if (bar && atc) {
    document.body.appendChild(bar);
    barBtn.addEventListener('click', function () {
      if (atc.disabled && notify) {
        window.scrollTo({ top: notify.getBoundingClientRect().top + pageYOffset - 120, behavior: 'smooth' });
        setTimeout(function () { if (nForm && !nForm.hidden) nForm.email.focus({ preventScroll: true }); }, 500);
        return;
      }
      if (!barBtn.disabled) atc.click();
    });
    new MutationObserver(syncSticky).observe(atc, { attributes: true, attributeFilter: ['class', 'disabled'] });
    syncSticky();

    var setOffset = function () {
      var off = 0;
      document.querySelectorAll('.apus-footer-mobile, .Avada-CookiesMobile').forEach(function (el) {
        var r = el.getBoundingClientRect();
        var st = getComputedStyle(el);
        if (st.display === 'none' || st.visibility === 'hidden' || !r.height) return;
        if (r.bottom >= innerHeight - 2 && r.top < innerHeight) off = Math.max(off, innerHeight - r.top);
      });
      bar.style.setProperty('--skp-bottom', off + 'px');
    };
    setOffset();
    setInterval(setOffset, 1000);
    addEventListener('resize', setOffset);

    var target = form.querySelector('[data-skp-buy]');
    var shown = null;
    var check = function () {
      var show = target.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      barBtn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('skp-sticky-on', show && matchMedia('(max-width: 1024px)').matches);
    };
    var raf = 0;
    addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; check(); });
    }, { passive: true });
    check();
  }

  /* Arriving from a sold-out card ("Notify me when back"): the theme ignores anchor jumps, so scroll here */
  if (notify && !notify.hidden && location.hash === '#skp-notify') {
    var goNotify = function () { window.scrollTo({ top: notify.getBoundingClientRect().top + pageYOffset - 120, behavior: 'smooth' }); };
    var arrive = function () {
      setTimeout(goNotify, 300);
      /* the theme can jump back to the top while it finishes loading; try once more if so */
      setTimeout(function () { if (pageYOffset < 50) goNotify(); }, 1600);
    };
    if (document.readyState === 'complete') arrive(); else addEventListener('load', arrive);
  }
})();